<template>
  <img class="w-auto" src="/images/MRBTA-logo.png" alt="Logo">
</template>
